<template>
    <v-row class="ma-0 pa-0 rounded align-center mr-2">
        <v-col cols="1">
            <v-btn color="primary" icon @click="$emit('refresh')" :loading="refreshing">
                <v-icon>refresh</v-icon>
            </v-btn>
        </v-col>

        <v-col cols="5" md="3">
            <v-text-field :value="startingBalance" @input="updateBalance" label="Saldo Iniziale Banca" prefix="€"
                type="number" outlined dense hide-details />
        </v-col>

        <v-col cols="6" md="3">
            <v-text-field :value="startingDate" label="Data Inizio Calcolo" outlined hide-details
                style="max-width: 160px !important" type="date" event-color="primary" @input="updateDate" />
        </v-col>
        <v-spacer />
        <!-- <v-btn color="primary" @click="saveSettings" :loading="saving"></v-btn> -->
        <v-col cols="4" md="2" class="text-center">
            <v-btn icon color="primary" @click="$emit('importaDati')" :loading="refreshing"
                v-tooltip.bottom="'Importa dati'">
                <v-icon>cloud_sync</v-icon>
            </v-btn>

            <div class="text-caption" :class="messageClass" style="min-height: 22px">
                {{ message }}
            </div>

        </v-col>

    </v-row>
</template>

<script>

export default {
    name: "CashflowSettings",

    props: {
        startingBalance: {
            type: Number,
            required: true
        },
        startingDate: {
            type: String,
            required: true, default: null
        },
        message: {
            type: String,
            default: ''
        },
    },

    data: () => ({
        menuDate: false,
        refreshing: false,
    }),

    computed: {
        messageClass() {
            return this.message.startsWith('Errore')
                ? 'error--text'
                : 'success--text';
        },
    },

    methods: {
        updateBalance(value) {
            this.$emit('update:starting-balance', Number(value));
        },

        updateDate(value) {
            this.$emit('update:starting-date', value);
            this.menuDate = false;
        }
    },
};
</script>